import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  AccordionDetails,
  Alert,
  Box,
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FileUpload } from 'src/components/common/FileUpload';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { archLevel } from 'src/data/config';
import { sendRequest } from 'src/hooks/useFetch';
import { useAppDispatch } from 'src/store';
import { setMessage } from 'src/store/Message';
import { useUser } from 'src/components/hooks/useUser';

const BootstrapDialogTitle = (props: { [x: string]: any; children: any; onClose: any }) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          {/* <CloseIcon /> */}
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

const SupportDocuments: React.FunctionComponent<any> = ({
  uploadDocuments,
  getSQCheListPILData,
  selectedSite,
  studyId,
  selectedCountry,
  newPilupdateKey,
  setIsNavigateToPannel,
  checkedInStartDate,
  selectedRowData
}) => {
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP;
  const [gridRows, setGridRows] = useState<any>([]);
  const [fileObject, setFileObject] = useState<any[]>([]);
  const [selectedDocName, setSelectdDocName] = useState<any>();
  const [isAddOtherDoc, setAddOtherDoc] = useState(true);
  const { checkPermission } = usePermissionWrapper();
  const [newAddRows, setnewAddRows] = useState<any>([]);
  const [isSubmitEnable, setIsSubmitEnable] = useState(false);
  const [isSaveBtnEnable, setIsSaveBtnEnable] = React.useState(false);
  const { user } = useUser();

  const { sqrFileUploadErrorMsg, sqcDataUpdateSuccessMsg, sqcMendatoryInfoErrorMsg, sqrFileDeleteSuccessMsg } =
    useFieldTranslation();
  const isDisable = checkPermission('update_sq_checklist_pil');
  const [openUploadDocument, setOpenUploadDocument] = React.useState(false);
  const [newAr, setNewAr] = useState<any>([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const dispatchApp = useAppDispatch();
  const [fileId, setFileId] = useState();
  const [rowId, setRowId] = useState();
  const [deleteSupporDocument, setdeleteSupporDocument] = useState(false);
  const [supportDocName, setSupportDocName] = useState();
  const [newRowId, setNewRowId] = useState();
  const [isDeleteNewRow, setIsDeleteRow] = useState(false);
  const [isError, setIsError] = useState(false);
  const [enable, setEnable] = useState<boolean>(false);

  const clearData = () => {
    setNewAr([]);
    setEnable(false);
    setOpenUploadDocument(false);
    setAddOtherDoc(true);
  };
  const handleUploadDocument = () => {
    const nameArr = newAr.map((ele: any) => {
      return ele.name;
    });
    const duplicate = nameArr.some((item: any, idx: number) => {
      return nameArr.indexOf(item) !== idx;
    });
    if (duplicate) {
      dispatchApp(setMessage({ msgDetails: 'Please Remove Duplicate file', severity: 'error' }));
    } else {
      setOpenUploadDocument(false);
      clearData();
      uploadDataFile();
      setIsSubmitEnable(false);
      setIsSaveBtnEnable(true);
      setIsNavigateToPannel(false);
    }
  };

  const uploadOtherDocuments = async (files: any): Promise<any> => {
    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
      const options = {
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME
        }
      };
      const response: any = await sendRequest('sqreport_filemaster_Other_Upload_Documents', options);

      return response;
    } catch {
      dispatchApp(setMessage({ msgDetails: sqrFileUploadErrorMsg, severity: 'error' }));
      return Promise.reject();
    }
  };

  const uploadDataFile = async (): Promise<any> => {
    if (newAr.length > 0) {
      const changedData: any = [];
      let fileExist: any = {};
      let newRowfileExist: any = {};

      gridRows.map((row: any) => {
        if (row.id == selectedDocName) {
          fileExist = newAr.filter((o1: any) => row.attachments.some((o2: any) => o1.path === o2.ctms_raw_file_name));
        }
      });
      if (newAddRows.length > 0) {
        newAddRows.map((row: any) => {
          if (row.id == selectedDocName) {
            newRowfileExist = newAr.filter((o1: any) =>
              row.attachments.some((o2: any) => o1.path === o2.ctms_raw_file_name)
            );
          }
        });
      }

      if (fileExist.length > 0 || newRowfileExist.length > 0) {
        dispatchApp(setMessage({ msgDetails: 'Duplicate document(s) identified', severity: 'error' }));
      } else {
        const result = await uploadOtherDocuments(newAr);
        setNewAr([]);
        clearData();
        if (Array.isArray(result)) {
          setFileObject([...fileObject, ...result]);
        }

        if (selectedDocName.includes != undefined && selectedDocName.includes('new')) {
          newAddRows.map((item: any) => {
            if (item.id == selectedDocName) {
              item.attachments = [...item.attachments, ...result];
            }
            changedData.push(item);
          });
          setnewAddRows(changedData);
        } else {
          gridRows.map((item: any) => {
            if (item.id == selectedDocName) {
              item.attachments = [...item.attachments, ...result];
            }
            changedData.push(item);
          });
          setGridRows(changedData);
        }
      }
    }

    setOpenUploadDocument(false);
  };
  const handleClickOpenUploadDocument = (selectedDoc: any) => {
    setSelectdDocName(selectedDoc);
    setOpenUploadDocument(true);
  };
  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;

    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File is too big. Max File Size is 5MB`;
    }
    return message;
  };

  const getData = () => {
    uploadDocuments != undefined && uploadDocuments.length > 0
      ? setGridRows(uploadDocuments)
      : setGridRows([
          {
            id: 0,
            is_selected: false,
            supporting_documentation: 'Current organizational chart and proposed management of the study',
            comment: '',
            attachments: []
          },

          {
            id: 1,
            is_selected: false,
            supporting_documentation: 'List of clinical trials (overall and completed recently)',

            comment: '',
            attachments: []
          },
          {
            id: 2,
            is_selected: false,
            supporting_documentation:
              'Copies of any publications by research staff relevant to clinical study under consideration',
            comment: '',
            attachments: []
          },
          {
            id: 3,
            is_selected: false,
            supporting_documentation:
              'Copies of current medical licenses and laboratory certification (if applicable) uploaded in ISF',
            comment: '',
            attachments: []
          },
          {
            id: 4,
            is_selected: false,
            supporting_documentation:
              'Sample source documentation of subject participation in a clinical study if difference from FICS forms',
            comment: '',
            attachments: []
          },

          {
            id: 5,
            is_selected: false,
            supporting_documentation: 'Estimate number of potential study subjects',
            comment: '',
            attachments: []
          },

          {
            id: 6,
            is_selected: false,
            supporting_documentation: 'Proposed recruitment strategy, including primary and secondary resources',
            comment: '',
            attachments: []
          }
        ]);
  };

  const checkValidation = () => {
    let isValid = true;
    if (newAddRows.length > 0) {
      newAddRows.map((newRow: any) => {
        if (newRow.supporting_documentation == '') {
          setIsError(true);
          isValid = false;
        }
      });
    }
    return isValid;
  };

  const postData = async () => {
    if (!checkValidation()) {
      dispatchApp(setMessage({ msgDetails: sqcMendatoryInfoErrorMsg, severity: 'error' }));
    } else {
      setIsError(false);
      const obj = gridRows.map((row: any) => {
        return {
          is_selected: row.is_selected,
          supporting_documentation: row.supporting_documentation,
          comment: row.comment,
          attachments: row.attachments.map((atta: any) => {
            return atta.id;
          })
        };
      });

      const newObj = newAddRows.map((row: any) => {
        return {
          is_selected: row.is_selected,
          supporting_documentation: row.supporting_documentation,
          comment: row.comment,
          attachments: row.attachments.map((atta: any) => {
            return atta.id;
          })
        };
      });

      const supportDocumentsObj: any = [...obj, ...newObj];
      const options: any = {
        site_id: selectedSite,
        study_id: studyId,
        data: {
          sq_checklist: {
            supporting_documentation: { support_documents: supportDocumentsObj }
          },
          monitoring_visit_id: selectedRowData.id,
          updated_by: user
        },
        pathVariables: {
          country: selectedCountry,
          appName: currentAppName
        }
      };
      try {
        if (newPilupdateKey) {
          await sendRequest('update_sqchecklistData', options);
        } else {
          await sendRequest('create_sqchecklistData', options);
        }
        dispatchApp(setMessage({ msgDetails: sqcDataUpdateSuccessMsg, severity: 'success' }));
        setAddOtherDoc(true);
        setIsSaveBtnEnable(false);
        setIsNavigateToPannel(true);
        getSQCheListPILData({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: currentAppName,
          monitoring_visit_id: selectedRowData.id
        });
        setnewAddRows([]);
      } catch (e) {
        dispatchApp(setMessage({ msgDetails: 'Error occurred while saving the data', severity: 'error' }));
        setnewAddRows([]);
      }
    }
  };

  const handleRemoveDocument = async (fileId: any, rowId: any) => {
    setConfirmDelete(true);
    setIsDeleteRow(false);
    setFileId(fileId);
    setRowId(rowId);
  };
  const handleRemoveItem = async () => {
    const changedData: any = [];
    try {
      const options = {
        file_id: fileId,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME
        }
      };
      await sendRequest('sqreport_delete_filemaster-Upload-Documents', options);
      gridRows.map((item: any) => {
        if (item.id == rowId) {
          item.attachments = item.attachments.filter((att: any) => att.id !== fileId);
        }
        changedData.push(item);
      });
      setGridRows(changedData);
      setConfirmDelete(true);
      setEnable(false);
      setConfirmDelete(false);
      setAddOtherDoc(true);
      dispatchApp(setMessage({ msgDetails: sqrFileDeleteSuccessMsg, severity: 'success' }));
      setIsSaveBtnEnable(true);
      setIsNavigateToPannel(false);
      clearData();
    } catch (e: any) {
      setEnable(false);
      setConfirmDelete(false);
      clearData();
      dispatchApp(setMessage({ msgDetails: e.message, severity: 'error' }));
    }
  };

  const handleChange = (e: any, rowId: any) => {
    const changedData: any = [];
    let checkAll = true;
    gridRows.map((item: any) => {
      if (item.id == rowId) {
        item.is_selected = e.target.checked;
      }
      changedData.push(item);
    });
    changedData.map((item: any) => {
      if (!item.is_selected) {
        checkAll = false;
      }
    });
    setcheckedAll(checkAll);
    setGridRows(changedData);
    setIsSaveBtnEnable(true);
    setIsNavigateToPannel(false);
  };

  // const handleTextChange = (e: any, rowId: any) => {
  //   const changedData: any = [];
  //   gridRows.map((item: any) => {
  //     if (item.id == rowId) {
  //       item.supporting_documentation = e.target.value;
  //     }
  //     changedData.push(item);
  //   });
  //   setGridRows(changedData);
  //   setIsSaveBtnEnable(true);
  // };
  const handleCommentTextChange = (e: any, rowId: any) => {
    const changedData: any = [];
    setcurrentEditId(rowId);
    gridRows.map((item: any) => {
      if (item.id == rowId) {
        item.comment = e.target.value;
      }
      changedData.push(item);
    });
    setGridRows(changedData);
    setIsSaveBtnEnable(true);
    setIsNavigateToPannel(false);
  };

  const stdDoc = [
    'Current organizational chart and proposed management of the study',
    'List of clinical trials (overall and completed recently)',
    'Copies of any publications by research staff relevant to clinical study under consideration',
    'Copies of current medical licenses and laboratory certification (if applicable) uploaded in ISF',
    'Sample source documentation of subject participation in a clinical study if difference from FICS forms',
    'Estimate number of potential study subjects',
    'Proposed recruitment strategy, including primary and secondary resources'
  ];

  const handleRemoveSupportDocument = (supportDocName: any) => {
    setdeleteSupporDocument(true);
    setSupportDocName(supportDocName);
  };

  const handleRemoveSupportDoc = async () => {
    if (supportDocName != '') {
      try {
        const options = {
          site_id: selectedSite,
          study_id: studyId,
          document_name: supportDocName,
          pathVariables: {
            country: selectedCountry,
            appName: process.env.REACT_APP_NAME
          }
        };
        await sendRequest('delete_sqchecklistData', options);
        setdeleteSupporDocument(false);
        setAddOtherDoc(true);
        dispatchApp(setMessage({ msgDetails: sqrFileDeleteSuccessMsg, severity: 'success' }));
        getSQCheListPILData({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: currentAppName,
          monitoring_visit_id: selectedRowData.id
        });
        setnewAddRows([]);
        setIsSaveBtnEnable(true);
      } catch (e: any) {
        dispatchApp(setMessage({ msgDetails: e.message, severity: 'error' }));
      }
    } else {
      setdeleteSupporDocument(false);
      setnewAddRows([]);
      setAddOtherDoc(true);
    }
  };

  const [currentEditId, setcurrentEditId] = useState(null);
  const handleEdit = (id: any) => {
    setcurrentEditId(id);
  };

  const handleAdd = () => {
    setnewAddRows([
      ...newAddRows,
      {
        id: `new${newAddRows.length}${1}`,
        is_selected: false,
        supporting_documentation: '',
        comment: '',
        attachments: []
      }
    ]);
    setAddOtherDoc(false);
  };

  const handleChangeNew = (e: any, rowId: any) => {
    const changedData: any = [];
    let checkAll = true;
    newAddRows.map((item: any) => {
      if (item.id == rowId) {
        item.is_selected = e.target.checked;
      }
      changedData.push(item);
    });

    changedData.map((item: any) => {
      if (!item.is_selected) {
        checkAll = false;
      }
    });
    setcheckedAll(checkAll);
    setnewAddRows(changedData);
    setIsSaveBtnEnable(true);
  };

  const handleTextChangeNew = (e: any, rowId: any) => {
    const changedData: any = [];
    setIsError(false);
    newAddRows.map((item: any) => {
      if (item.id == rowId) {
        item.supporting_documentation = e.target.value;
      }
      changedData.push(item);
    });
    setnewAddRows(changedData);
    setIsSaveBtnEnable(true);
  };
  const handleCommentTextChangeNew = (e: any, rowId: any) => {
    const changedData: any = [];
    newAddRows.map((item: any) => {
      if (item.id == rowId) {
        item.comment = e.target.value;
      }
      changedData.push(item);
    });
    setnewAddRows(changedData);
    setIsSaveBtnEnable(true);
  };

  const handleRemoveItemNew = async (fileId: any, rowId: any) => {
    const isConfirmed = window.confirm('Do you want to delete the uploaded document?');

    if (isConfirmed) {
      const changedData: any = [];
      try {
        const options = {
          file_id: fileId,
          pathVariables: {
            study_id: studyId,
            country: selectedCountry,
            site_id: selectedSite,
            appName: process.env.REACT_APP_NAME
          }
        };
        await sendRequest('sqreport_delete_filemaster-Upload-Documents', options);
        newAddRows.map((item: any) => {
          if (item.id == rowId) {
            item.attachments = item.attachments.filter((att: any) => att.id !== fileId);
          }
          changedData.push(item);
        });
        setnewAddRows(changedData);
        setIsSaveBtnEnable(true);
        dispatchApp(setMessage({ msgDetails: sqrFileDeleteSuccessMsg, severity: 'success' }));
      } catch (e: any) {
        dispatchApp(setMessage({ msgDetails: e.message, severity: 'error' }));
      }
    }
  };

  const handleCloseUploadDocument = () => {
    setEnable(true);
  };
  const handleClosePopUp = () => {
    setEnable(false);
  };

  const handleCloseSupportDialog = () => {
    setdeleteSupporDocument(false);
  };

  const handleCloseCofirmDialog = () => {
    setConfirmDelete(false);
  };

  useEffect(() => {
    getData();
  }, [uploadDocuments]);

  const [checkedAll, setcheckedAll] = useState(false);
  const handleChangeCheckAll = (e: any) => {
    if (e.target.checked) {
      const changedData: any = [];
      gridRows.map((item: any) => {
        item.is_selected = true;
        changedData.push(item);
      });
      setGridRows(changedData);
      const changedDataNew: any = [];
      newAddRows.map((item: any) => {
        item.is_selected = true;
        changedDataNew.push(item);
      });
      setnewAddRows(changedDataNew);
      setcheckedAll(true);
    } else {
      const changedData: any = [];
      gridRows.map((item: any) => {
        item.is_selected = false;
        changedData.push(item);
      });
      setGridRows(changedData);
      const changedDataNew: any = [];
      newAddRows.map((item: any) => {
        item.is_selected = false;
        changedDataNew.push(item);
      });
      setnewAddRows(changedDataNew);
      setcheckedAll(false);
    }
  };

  const handleRemoveRow = (delRowId: any) => {
    setNewRowId(delRowId);
    setConfirmDelete(true);
    setIsDeleteRow(true);
  };

  const removeNewRow = () => {
    const files = newAddRows.filter((item: any) => item.id !== newRowId);
    setnewAddRows(files);
    setConfirmDelete(false);
    setAddOtherDoc(true);
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab" sx={{ pr: 1 }}>
        <Grid container className="checkbox-block">
          <div className="supportingDocWrapper">
            <Box sx={{ height: 350, width: '100%' }}>
              <TableContainer component={Paper} className="customDataTable" sx={{ maxHeight: 340 }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox" width={42}>
                        <Checkbox
                          disabled={!isDisable || !checkedInStartDate}
                          color="primary"
                          autoFocus
                          // indeterminate={numSelected > 0 && numSelected < rowCount}
                          checked={checkedAll}
                          onChange={(e: any) => handleChangeCheckAll(e)}
                          inputProps={{
                            'aria-label': 'select checkbox'
                          }}
                        />
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: 275, flex: 1 }}>
                        Supporting Document
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: 275, flex: 1 }}>
                        Comment
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: 180, flex: 1 }}>
                        Attachments
                      </TableCell>
                      <TableCell align="left" width={30}>
                        &nbsp;
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {gridRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell align="left" valign="top" width={42} className="checkBoxCol">
                          <Checkbox
                            color="primary"
                            value={row.is_selected}
                            disabled={!isDisable || !checkedInStartDate}
                            onChange={(e: any) => handleChange(e, row.id)}
                            checked={row.is_selected ? true : false}
                          />
                        </TableCell>
                        <TableCell align="left" valign="top" width="25%" className="editableTd">
                          {row.supporting_documentation}
                        </TableCell>
                        <TableCell align="left" valign="top" width="25%" className="editableTd">
                          <div className="editableCol">
                            {row.comment != '' ? (
                              <IconButton
                                aria-label="Edit this Comment content"
                                disabled={!isDisable || !checkedInStartDate}
                                onClick={() => handleEdit(row.id)}
                              >
                                <EditIcon />
                              </IconButton>
                            ) : null}
                            {row.comment == '' || row.id == currentEditId ? (
                              <TextField
                                key={row.id}
                                onBlur={() => setcurrentEditId(null)}
                                value={row.comment}
                                name="comment"
                                autoFocus
                                onFocus={e => {
                                  const val = e.target.value;
                                  e.target.value = '';
                                  e.target.value = val;
                                }}
                                multiline
                                maxRows={4}
                                label=""
                                variant="standard"
                                inputProps={{ maxLength: 199 }}
                                disabled={!isDisable || !checkedInStartDate}
                                onChange={(e: any) => handleCommentTextChange(e, row.id)}
                              />
                            ) : (
                              row.comment
                            )}

                            {/* <TextField
                                value={row.comment}
                                name="comment"
                                multiline
                                maxRows={4}
                                label=""
                                variant="standard"
                                inputProps={{ maxLength: 199 }}
                                //disabled={row.comment!=null && row.id == currentEditId}
                                onChange={(e: any) => handleCommentTextChange(e, row.id)}
                              /> */}
                          </div>
                        </TableCell>
                        <TableCell align="left" className="chipCol" valign="top">
                          <div className="chipColInner">
                            {row.attachments != undefined &&
                              row.attachments.length > 0 &&
                              row.attachments.map((item: any) => {
                                // {fileObject.map((item: any) => {
                                return (
                                  <Chip
                                    key={item.id}
                                    label={item.ctms_raw_file_name}
                                    variant="outlined"
                                    color="primary"
                                    disabled={
                                      !checkPermission('mange_sq_checklist_docs') || !isDisable || !checkedInStartDate
                                    }
                                    onDelete={() => handleRemoveDocument(item.id, row.id)}
                                  />
                                );
                              })}
                            {checkPermission('mange_sq_checklist_docs') && isDisable ? (
                              <Button
                                disabled={!isDisable || !checkedInStartDate}
                                variant="text"
                                onClick={() => handleClickOpenUploadDocument(row.id)}
                                startIcon={<AddOutlinedIcon />}
                              >
                                Upload
                              </Button>
                            ) : (
                              ''
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="right" width={30}>
                          {!stdDoc.includes(row.supporting_documentation) &&
                          checkPermission('mange_sq_checklist_docs') &&
                          isDisable ? (
                            <IconButton
                              disabled={!isDisable || !checkedInStartDate}
                              aria-label="delete"
                              onClick={() => handleRemoveSupportDocument(row.supporting_documentation)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          ) : (
                            ''
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                    {newAddRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell align="center" valign="top" width={42} className="checkBoxCol">
                          <Checkbox
                            color="primary"
                            disabled={!isDisable || !checkedInStartDate}
                            value={row.is_selected}
                            onChange={(e: any) => handleChangeNew(e, row.id)}
                            checked={row.is_selected ? true : false}
                          />
                        </TableCell>
                        <TableCell align="left" valign="top" width="25%" className="editableTd">
                          <TextField
                            value={row.supporting_documentation}
                            name="supporting_documentation"
                            placeholder="Supporting document *"
                            variant="standard"
                            required
                            multiline
                            maxRows={4}
                            error={isError}
                            autoFocus
                            onChange={(e: any) => handleTextChangeNew(e, row.id)}
                          />
                        </TableCell>
                        <TableCell align="left" valign="top" width="25%" className="editableTd">
                          <TextField
                            value={row.comment}
                            name="supporting_documentation"
                            placeholder="Comment"
                            inputProps={{ maxLength: 199 }}
                            variant="standard"
                            multiline
                            maxRows={4}
                            onChange={(e: any) => handleCommentTextChangeNew(e, row.id)}
                          />
                        </TableCell>
                        <TableCell align="left" className="chipCol" valign="top">
                          <div className="chipColInner">
                            {row.attachments != undefined &&
                              row.attachments.length > 0 &&
                              row.attachments.map((item: any) => {
                                // {fileObject.map((item: any) => {
                                return (
                                  <Chip
                                    key={item.id}
                                    label={item.ctms_raw_file_name}
                                    variant="outlined"
                                    color="primary"
                                    disabled={
                                      !checkPermission('mange_sq_checklist_docs') || !isDisable || !checkedInStartDate
                                    }
                                    onDelete={() => handleRemoveItemNew(item.id, row.id)}
                                  />
                                );
                              })}
                            {checkPermission('mange_sq_checklist_docs') && isDisable ? (
                              <Button
                                variant="text"
                                onClick={() => handleClickOpenUploadDocument(row.id)}
                                startIcon={<AddOutlinedIcon />}
                              >
                                Upload
                              </Button>
                            ) : (
                              ''
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="right" width={30} className="actionCol">
                          <IconButton aria-label="delete" onClick={() => handleRemoveRow(row.id)}>
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            {checkPermission('mange_sq_checklist_docs') && isDisable ? (
              <Button
                variant="text"
                className="textBtnwIcon"
                disabled={!isDisable || !checkedInStartDate || !isAddOtherDoc}
                startIcon={<AddCircleOutlinedIcon />}
                onClick={handleAdd}
              >
                Add Other Document
              </Button>
            ) : (
              ''
            )}
          </div>
          <Grid container spacing={2}>
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                {isDisable ? (
                  <Button
                    disabled={!isSaveBtnEnable || !checkedInStartDate}
                    onClick={() => {
                      postData();
                    }}
                    variant="text"
                  >
                    SAVE
                  </Button>
                ) : (
                  ''
                )}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid>
        <div>
          <PopupComponent
            //onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openUploadDocument}
            maxWidth="md"
            className="uploadModal"
          >
            <DialogContent sx={{ p: 2 }}>
              <FileUpload
                showPreviewsInDropzone={false}
                className={'uploadFile withFakeBtn multiple'}
                onChange={files => {
                  if (files.length > 0) {
                    setNewAr([...files]);
                    //setUploadedFiles([...uploadedFiles, ...files]);
                    setIsSubmitEnable(true);
                  } else {
                    setIsSubmitEnable(false);
                  }
                }}
                isUpload
                defaultMsg={'Your file upload has been successfully initiated'}
                successMsg={'Drag and drop your file here or'}
                fileObjects={fileObject}
                maxFileSize={5000000}
                showPreviews
                useChipsForPreview
                previewText=""
                getDropRejectMessage={handleRejectedMessage}
                acceptedFiles={[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ]}
              />
            </DialogContent>
            <Alert severity="info" sx={{ mr: 2, ml: 2 }}>
              Documents uploaded here are not stored in eISF
            </Alert>
            <DialogActions>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="text"
                  href="#contained-buttons"
                  className="grey-btn"
                  onClick={handleCloseUploadDocument}
                >
                  Cancel
                </Button>
                <Button
                  variant="text"
                  href="#contained-buttons"
                  onClick={handleUploadDocument}
                  disabled={!isSubmitEnable}
                >
                  Submit
                </Button>
              </Stack>
            </DialogActions>
          </PopupComponent>
        </div>
        <PopupComponent open={enable} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to cancel uploading this document?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={clearData} autoFocus className='grey-btn'>
              Yes
            </Button>
            <Button onClick={handleClosePopUp}>No</Button>
          </DialogActions>
        </PopupComponent>

        <PopupComponent open={confirmDelete}>
          <DialogTitle id="alert-dialog-title">
            {isDeleteNewRow ? 'Delete supporting document data' : 'Delete Document?'}
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              {isDeleteNewRow
                ? 'Do you want to delete this supporting document data?'
                : 'Do you want to delete Document?'}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => (isDeleteNewRow ? removeNewRow() : handleRemoveItem())}
              className="grey-btn"
              autoFocus
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                handleCloseCofirmDialog();
              }}
            >
              No
            </Button>
          </DialogActions>
        </PopupComponent>

        <PopupComponent open={deleteSupporDocument}>
          <DialogTitle id="alert-dialog-title">{'Delete supporting document data?'}</DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom id="alert-dialog-description">
              Do you want to delete this supporting document data?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleRemoveSupportDoc()} className="grey-btn" autoFocus>
              Yes
            </Button>
            <Button
              onClick={() => {
                handleCloseSupportDialog();
              }}
            >
              No
            </Button>
          </DialogActions>
        </PopupComponent>
      </Grid>
    </>
  );
};

export default SupportDocuments;
